import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Award, Home } from 'lucide-react';

const AboutSection = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: [0.22, 1, 0.36, 1],
      },
    },
  };

  return (
    <section id="about" className="bg-[#0A1628] py-24 md:py-32 relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-20 left-10 w-72 h-72 bg-[#60A5FA] rounded-full filter blur-3xl" />
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#3B82F6] rounded-full filter blur-3xl" />
      </div>

      <motion.div
        ref={ref}
        variants={containerVariants}
        initial="hidden"
        animate={inView ? 'visible' : 'hidden'}
        className="max-w-7xl mx-auto px-6 relative z-10"
      >
        {/* Section Number */}
        <motion.div variants={itemVariants} className="mb-8">
          <span className="text-[#60A5FA] text-lg font-mono">01</span>
        </motion.div>

        {/* Section Title */}
        <motion.h2 variants={itemVariants} className="text-5xl md:text-6xl font-bold text-white mb-16">
          Sobre <span className="text-[#60A5FA]">Nosotros</span>
        </motion.h2>

        <div className="grid md:grid-cols-2 gap-12">
          {/* Mission */}
          <motion.div variants={itemVariants} className="space-y-6">
            <div className="flex items-center space-x-4 mb-6">
              <div className="w-12 h-12 bg-[#60A5FA]/20 rounded-full flex items-center justify-center">
                <Award className="w-6 h-6 text-[#60A5FA]" />
              </div>
              <h3 className="text-3xl font-bold text-white">Nuestro propósito</h3>
            </div>
            <p className="text-white/70 text-lg leading-relaxed">
              Nuestra misión es demostrar nuestra pasión por los autos a través del cuidado estético profesional,
              utilizando productos y técnicas de alta calidad con el objetivo de superar las expectativas de cada cliente.
            </p>
          </motion.div>

          {/* Trajectory */}
          <motion.div variants={itemVariants} className="space-y-6">
            <div className="flex items-center space-x-4 mb-6">
              <div className="w-12 h-12 bg-[#60A5FA]/20 rounded-full flex items-center justify-center">
                <Home className="w-6 h-6 text-[#60A5FA]" />
              </div>
              <h3 className="text-3xl font-bold text-white">Nuestra trayectoria</h3>
            </div>
            <p className="text-white/70 text-lg leading-relaxed">
              Contamos con 3 años en el mercado ofreciendo servicios de detailing automotriz tanto para clientes
              particulares como para empresas.
            </p>
            <div className="inline-block bg-[#60A5FA]/20 backdrop-blur-sm border border-[#60A5FA]/30 px-6 py-3 rounded-full mt-6">
              <p className="text-[#60A5FA] font-semibold flex items-center">
                <Home className="w-4 h-4 mr-2" />
                Servicio a domicilio
              </p>
            </div>
          </motion.div>
        </div>
      </motion.div>
    </section>
  );
};

export default AboutSection;
